export const radiusMd = 6;
export const radiusLg = 12;
export const spacingSm = 8;
export const spacingMd = 16;
export const spacingLg = 24;
